import { Typography, TypographyProps } from "@mui/material";

export default (props: TypographyProps) => (
    <Typography
        variant="h4"
        marginBottom={2}
        {...props}
    />
)